// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InternalendpointsSessionSummary
 */
export interface InternalendpointsSessionSummary {
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  alias?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  auraDatabaseId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  auraInstanceId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  cloudProvider?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  consoleProjectId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  consoleUserId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  databaseUsername?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  databaseUuid?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof InternalendpointsSessionSummary
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InternalendpointsSessionSummary
   */
  isTerminated?: boolean;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  orchestra?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionSummary
   */
  terminationReason?: string;
}

/**
 * Check if a given object implements the InternalendpointsSessionSummary interface.
 */
export function instanceOfInternalendpointsSessionSummary(
  value: object,
): value is InternalendpointsSessionSummary {
  return true;
}

export function InternalendpointsSessionSummaryFromJSON(
  json: any,
): InternalendpointsSessionSummary {
  return InternalendpointsSessionSummaryFromJSONTyped(json, false);
}

export function InternalendpointsSessionSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsSessionSummary {
  if (json == null) {
    return json;
  }
  return {
    alias: json['alias'] == null ? undefined : json['alias'],
    auraDatabaseId:
      json['aura_database_id'] == null ? undefined : json['aura_database_id'],
    auraInstanceId:
      json['aura_instance_id'] == null ? undefined : json['aura_instance_id'],
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    consoleProjectId:
      json['console_project_id'] == null
        ? undefined
        : json['console_project_id'],
    consoleUserId:
      json['console_user_id'] == null ? undefined : json['console_user_id'],
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    databaseUsername:
      json['database_username'] == null ? undefined : json['database_username'],
    databaseUuid:
      json['database_uuid'] == null ? undefined : json['database_uuid'],
    id: json['id'] == null ? undefined : json['id'],
    isDeleted: json['is_deleted'] == null ? undefined : json['is_deleted'],
    isTerminated:
      json['is_terminated'] == null ? undefined : json['is_terminated'],
    memory: json['memory'] == null ? undefined : json['memory'],
    orchestra: json['orchestra'] == null ? undefined : json['orchestra'],
    region: json['region'] == null ? undefined : json['region'],
    terminationReason:
      json['termination_reason'] == null
        ? undefined
        : json['termination_reason'],
  };
}

export function InternalendpointsSessionSummaryToJSON(
  json: any,
): InternalendpointsSessionSummary {
  return InternalendpointsSessionSummaryToJSONTyped(json, false);
}

export function InternalendpointsSessionSummaryToJSONTyped(
  value?: InternalendpointsSessionSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alias: value['alias'],
    aura_database_id: value['auraDatabaseId'],
    aura_instance_id: value['auraInstanceId'],
    cloud_provider: value['cloudProvider'],
    console_project_id: value['consoleProjectId'],
    console_user_id: value['consoleUserId'],
    created_at: value['createdAt'],
    database_username: value['databaseUsername'],
    database_uuid: value['databaseUuid'],
    id: value['id'],
    is_deleted: value['isDeleted'],
    is_terminated: value['isTerminated'],
    memory: value['memory'],
    orchestra: value['orchestra'],
    region: value['region'],
    termination_reason: value['terminationReason'],
  };
}
